import styled from 'styled-components';
import { Button } from '~/ui/buttons';
import PenEditIcon from '~/assets/icons/penEdit.svg';
import ColorPickerIconSvg from '~/assets/icons/colorPicker.svg';

export const EditBtnIcon = styled(PenEditIcon)``;

export const ColorPickerIcon = styled(ColorPickerIconSvg)`
  margin-left: 1px;
`;

/** Compact editor chrome — resets EDS primary Button sizing (min-height 46px). */
export const EditBtn = styled(Button)`
  background-color: #f3ecff;
  color: #9738ff;
  padding: 5px;
  min-height: 0;
  height: auto;
  width: 28px;
  line-height: 0;
  font-size: 0;
  font-weight: normal;
  gap: 0;

  position: absolute;
  top: 5px;
  right: 5px;
  margin: 0;

  &:hover:not(:disabled) {
    color: #fff;
    background-color: #9738ff;
    svg {
      path {
        fill: #fff !important;
      }
    }
  }
  &.active {
    background-color: #9845fb;
  }
`;
